var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyRupiahCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-5 h-5 text-icon-color-warning dark:text-dark-icon-color-warning",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05 7.225a1 1 0 0 1 1-1h1.82a3.1 3.1 0 0 1 3.1 3.1v.14a2.96 2.96 0 0 1-1.457 2.55l1.321 2.266a1 1 0 0 1-1.727 1.008l-1.67-2.864H9.05v2.36a1 1 0 1 1-2 0zm2 3.2h.96c.53 0 .96-.43.96-.96v-.14a1.1 1.1 0 0 0-1.1-1.1h-.82zM13.47 12a1 1 0 0 1 1-1h1.54a2.54 2.54 0 0 1 0 5.08h-.54v1.24a1 1 0 1 1-2 0zm2 2.08h.54a.54.54 0 0 0 0-1.08h-.54z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupiahCircle);
export default __webpack_public_path__ + "static/media/CurrencyRupiahCircle.f2152bd28d9a71c919d8912728d6ac36.svg";
export { ForwardRef as ReactComponent };